export default "__VITE_PUBLIC_ASSET__715510ee__"